<template>
  <div>
    <SubNav
      :link="{
        text: '&lt; Back to User Management',
        href: 'list',
        class: 'text-danger',
      }"
    />
    <div class="container-fluid p-5">
      <div class="border">
        <div v-loading="loading || updating" class="row p-4">
          <div class="col-12 mb-3">
            <h4 class="text-primary mt-2">Edit User</h4>
            <strong>User Details</strong>
          </div>
          <div class="col-md-3 mb-3">
            <label for="firstName">First name</label>
            <input id="firstName" v-model="user.first_name" type="text" class="form-control" />
          </div>
          <div class="col-md-3 mb-3">
            <label for="lastName">Last name</label>
            <input id="lastName" v-model="user.last_name" type="text" class="form-control" />
          </div>
          <div class="col-md-6 mb-3">
            <label for="email">Email</label>
            <input id="email" v-model="user.email" type="email" class="form-control" disabled />
          </div>
          <dropCard
            name="role"
            placeholder="Please select role"
            label="Select Role"
            :list="roles"
            :value.sync="selectedRole"
          >
            <!--  <CreateRole /> -->
          </dropCard>
          <div class="col-12 my-5">
            <b-button class="btn btn-primary mr-3" @click="onUpdate">Update and Save</b-button>
            <b-button variant="outline-danger" class="border-0" @click="onDelete"
              >Delete User</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from "../../components/SubNav.vue";
import dropCard from "../../components/dropCard.vue";
// import CreateRole from "../roles/components/Create.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Profile",
  components: { SubNav, dropCard },
  data() {
    return {
      user: {
        email: "",
        username: "",
        first_name: "",
        last_name: "",
      },
      selectedRole: 0,
      roles: [
        { id: 0, name: "data_viewer" },
        { id: 1, name: "data manager" },
        { id: 2, name: "super admin" },
        { id: 3, name: "admin" },
      ],
      userRole: undefined,
      updating: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["users"]),
    role() {
      return this.roles[this.selectedRole] || "";
    },
    userId() {
      return this.$route.query.userId;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      if (!this.users.length) await this.loadusers();
      // if (!this.roles.length) await this.loadroles();
      this.user = await this.getUser(this.userId);
      this.selectedRole = this.roles.findIndex((role) => role.name === this.user.group);
      this.userRole = this.selectedRole;
    } catch (error) {
      console.log(error);
      this.$router.push("/users/list");
    }
    this.loading = false;
  },
  methods: {
    ...mapActions("users", [
      "getUser",
      "loadusers",
      "loadroles",
      "updateUser",
      "updateUserRole",
      "deleteUser",
    ]),
    onUpdate() {
      this.updating = true;
      const user = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        username: this.user.username,
      };
      this.updateUser({ id: this.userId, user })
        .then(() => {
          if (this.userRole !== this.selectedRole) {
            this.updateUserRole({ userId: this.userId, type: this.selectedRole })
              .then(() => {
                this.$notify.success("Success");
                this.$router.push("/users/list");
              })
              .catch((err) => {
                console.log(err);
                this.$notify.error("An error occured!");
              });
          } else {
            this.$notify.success("Success");
            this.$router.push("/users/list");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error("An error occured!");
        })
        .finally(() => {
          this.updating = false;
        });
    },
    onDelete() {
      this.updating = true;
      this.deleteUser(this.userId)
        .then(() => {
          this.$notify.success("User Removed Successfully");
          this.$router.push("/users/list");
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error("An error occured!");
        })
        .finally(() => {
          this.updating = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-roles {
  max-height: 270px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>
